<template>
  <transition name="fade">
    <div styleName="index_header_wrapper" class="fade-wp" v-if="show">
      <div styleName="index_header_inner_wp">
        <div styleName="index_header">
          <span styleName="index_header_icon"></span>
          <span styleName="index_header_title">{{title}}</span>
          <span styleName="index_header_close_btn" @click="close"></span>
        </div>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'

export default {
  name: 'CommonHeader',
  mixins: [CSSModules(styles)],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
